<template>

  <module-template :title="resolveTitle()" :subtitle="subtitle">
    <router-view></router-view>
  </module-template>

</template>
<script>
  import ModuleTemplate from 'components/root/main/ModuleTemplate.vue'

  export default{
    props: ['appendToTitle', 'subtitle'],
    methods: {
      resolveTitle() {
        return this.$t('profile');
      }
    },
    components: {
        ModuleTemplate
    }
  }
</script>



// WEBPACK FOOTER //
// Profile.vue?092a1a25